import React from 'react';
import {FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';

const LoadEventsButton = ({onClick}, {translations}) => (
    <div className='load-more-events-container'>
        <button
            className='load-more-events-button'
            onClick={onClick}
        ><FormattedMessage id="thread.load_previous_events"/>
        </button>
    </div>
);

LoadEventsButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

export default LoadEventsButton;
